import type { TmWrappers } from '@/wrappers'
import type { RegisteredServices } from '@/core/container/types'

export type WebWidgetModalParams = {
  editingId?: string
  saveCallback?: () => unknown
}

export type CopyWebWidgetModalParams = {
  editingId: string
}

export type SendWidgetInstructionsModalParams = {
  editingId: string
}

export const webWidgetModalId = 'webWidgetModal' satisfies TmWrappers
export const copyWebWidgetModalId = 'copyWebWidgetModal' satisfies TmWrappers
export const sendWidgetInstructionsModalId = 'sendWidgetInstructionsModal' satisfies TmWrappers

export const webWidgetTableId = 'webWidgetTable' as RegisteredServices
